$(function () {

  const player = videojs('player', {
    controls: true,
    autoplay: false,
    preload: 'auto'
  });

});
